<!--
 * @Desc: 
 * @Author: may.li
 * @Date: 2023-06-12 11:38:06
 * @LastEditors: may.li
 * @LastEditTime: 2023-06-12 14:03:49
-->
<template>
	<div class="page page_fans page_adress">
		<van-list v-model="loading" :finished="finished" finished-text="没有更多了" @load="getData">
			<div class="list">
				<div class="item" v-for="(item,index) in dataList" :key="index">
					<div class="item-l">
						<div class="info-val">码编号：{{ item.qrcode_num }}</div>
						<div class="info-val">备注：{{ item.mark }}</div>
					</div>
					<div class="item-btn" @click="toDetail(item.id)">扫码记录</div>
				</div>
			</div>
		</van-list>
	</div>
</template>
<script>
export default {
	data(){
		return{
			token: null,
			uuid: null,
			page: 1,
			size: 10,
			dataList: [],
			loading: false,
			finished: false,
		}
	},
	created() {
		this.token = this.$store.getters.token;
		this.uuid = this.$route.query.uuid;
	},
	methods: {
		/**
		 * @name: 获取二维码
		 * @return {*}
		 * @desc: 
		 */		
		getData(){
			let params = {
				token: this.token,
				page: this.page,
				size: this.size,
				user_uuid: this.uuid
			};
			this.$api.agent.agnetQrcodes(params).then(res=>{
				if(res.code == 200){
					let list = res.result;
					if(list && list.length){
						if(this.page == 1){
							this.dataList = list;
						}else{
							for(let i in list){
								this.dataList.push(list[i])
							};
						}
						if(list.length < this.size){
							this.finished = true;
						}else{
							this.page++;
							this.loading = false;
						}
					}else{
						this.finished = true;
					}
				}else{
					this.finished = true;
					this.$toast(res.message);
				}
			})
		},
		/**
		 * @name: 进详情
		 * @return {*}
		 * @desc: 
		 */		
		toDetail(id){
			this.$router.push({
				path: '/agent/qrcode/detail',
				query: {
					id: id
				}
			})
		}
	},
}
</script>
<style scoped>
	.item .item-btn{
		padding: 0 0.2rem;
		height: 0.67rem;
		text-align: center;
		line-height: 0.67rem;
		font-size: 0.35rem;
		border-radius: 0.33rem;
		margin-right: 0.4rem;
		color: rgba(211, 68, 68, 1);
		border: 0.0267rem solid rgba(211, 68, 68, 1);
	}
</style>